export default function EmptyState({ icon: Icon, title, description, action, testid }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-12 px-6" data-testid={testid || "empty-state"}>
      {Icon && (
        <div className="w-12 h-12 rounded-full bg-secondary flex items-center justify-center mb-4">
          <Icon className="w-6 h-6 text-muted-foreground" />
        </div>
      )}
      <p className="font-heading font-semibold text-foreground">{title}</p>
      {description && <p className="text-sm text-muted-foreground mt-1 max-w-sm">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
